"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Modal = _interopRequireDefault(require("../../common/Modal/Modal"));
var _ConfirmSingleReportForm = _interopRequireDefault(require("./ConfirmSingleReportForm"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ConfirmSingleReportModal = function ConfirmSingleReportModal(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("core"),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    isOpen: props.isOpen,
    title: t("Create Single Report"),
    customClass: "confirm-report-modal",
    close: props.close,
    footer: {
      buttonText: t("Create Report"),
      buttonStyle: 'additive',
      onClick: function onClick() {
        return props.generateReport(props.payload);
      }
    }
  }, /*#__PURE__*/_react["default"].createElement(_ConfirmSingleReportForm["default"], {
    payload: props.payload
  }));
};
ConfirmSingleReportModal.propTypes = {
  payload: _propTypes["default"].object,
  close: _propTypes["default"].func.isRequired
};
ConfirmSingleReportModal.defaultProps = {
  payload: {
    type: '',
    startDate: '',
    endDate: ''
  }
};
var _default = exports["default"] = ConfirmSingleReportModal;